export default __webpack_public_path__ + "static/media/cabinet.d8ffd3ff.png";